export const DYNAMIC_TABLE_DATA_ELEMENT = '[data-element="dynamic-table"]';

// CLASSES
export const COMPONENT_CLASS = 'at-dynamic-table';
export const SHADOW_CLASS = `${COMPONENT_CLASS}__shadow`;

// SELECTORS
export const TABLE_SELECTOR = '.at-table';
export const TABLE_CONTAINER_SELECTOR = '.table-container';
export const COMPONENT_SELECTOR = `.${COMPONENT_CLASS}`;
export const SHADOW_SELECTOR = `.${SHADOW_CLASS}`;
export const NAVIGATION_SELECTOR = `${COMPONENT_SELECTOR}__navigation`;
export const NAVIGATION_PREV_BUTTON_SELECTOR = `${COMPONENT_SELECTOR}__navigation-prev`;
export const NAVIGATION_NEXT_BUTTON_SELECTOR = `${COMPONENT_SELECTOR}__navigation-next`;
export const HEADER_TITLE_SELECTOR = `${COMPONENT_SELECTOR}__header-title`;

export const HEADER_CELL_TAG = 'thead th';
export const BODY_ROW_TAG = 'tbody tr';

export const SCREENSIZE_SM = 640;
export const SWIPE_THRESHOLD = 50;